import { render, staticRenderFns } from "./SwiperContainer.vue?vue&type=template&id=2e9d04cd&"
import script from "./SwiperContainer.vue?vue&type=script&lang=js&"
export * from "./SwiperContainer.vue?vue&type=script&lang=js&"
import style0 from "./SwiperContainer.vue?vue&type=style&index=0&id=2e9d04cd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@5.2.7_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports